import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {IAOPTIONS_ROUTES} from "@constants"
import IframePage from "./iframe"


export const IaOptionsRoutes = {
    path: IAOPTIONS_ROUTES.PATH,
    title: IAOPTIONS_ROUTES.TITLE,
    accessKey: IAOPTIONS_ROUTES.ACCESS_KEY,
    icon: 'sparkles',
    element: <AppLayout />,
    hideInHome: true,
    children: [{
        element: <Navigate to={IAOPTIONS_ROUTES.VISUALIZATION_PATH} />, index: true
    }, {
        title: 'General',
        path: IAOPTIONS_ROUTES.GENERAL_PATH,
        dashboardKey: 'iaoptions-general',
        element: <IframePage url={IAOPTIONS_ROUTES.GENERAL_LINK} />
    }, {
        title: 'Visualization',
        path: IAOPTIONS_ROUTES.VISUALIZATION_PATH,
        dashboardKey: 'iaoptions-visualization',
        element: <IframePage url={IAOPTIONS_ROUTES.VISUALIZATION_LINK} />
    }, {
        title: 'Edition',
        path: IAOPTIONS_ROUTES.EDITION_PATH,
        dashboardKey: 'iaoptions-edition',
        element: <IframePage url={IAOPTIONS_ROUTES.EDITION_LINK} />
    }]
}